export default {
  sounds: {
    'basic-button-click': '/sounds/Menu_General/0-UI-Buttonclick-448080__breviceps__wet-click.mp3',
    'basic-menu-music': '/sounds/Menu_General/0-Menu-Backgroundmusic-Funshine.mp3',
  },
  animations: {
    'dashboard-animation-cockpit-nici': '/animations/dashboard/Cockpit-Nici/Cockpit-Nici.json',
    'dashboard-animation-cockpit-nick': '/animations/dashboard/Cockpit-Nick/Cockpit-Nick.json',
    'dashboard-animation-background-cockpit-nici':
      '/animations/dashboard/intro-uebergang-nici/intro-uebergang-nici.json',
    'dashboard-animation-background-cockpit-nick':
      '/animations/dashboard/intro-uebergang-nick/intro-uebergang-nick.json',
    'dashboard-animation-background-schwenk-nici':
      '/animations/dashboard/Nici-Charakterauswahl-Schwenk/Nici-Charakterauswahl-Schwenk.json',
    'dashboard-animation-background-schwenk-nick':
      '/animations/dashboard/Nick-Charakterauswahl-Schwenk/Nick-Charakterauswahl-schwenk.json',
    'dashboard-animation-steckbrief-nici':
      '/animations/dashboard/Nici-Steckbrief/Nici-steckbrief.json',
    'dashboard-animation-steckbrief-nick':
      '/animations/dashboard/Nick-Steckbrief/Nick-steckbrief.json',
    'dashboard-animation-steckbrief-rosa':
      '/animations/dashboard/Rosa-Steckbrief/Rosa-steckbrief.json',
    'dashboard-animation-char-auswahl-nick':
      '/animations/dashboard/Nick-Characterauswahl/Nick-characterauswahl.json',
    'dashboard-animation-char-auswahl-nici':
      '/animations/dashboard/Nici-Steckbrief/Nici-steckbrief.json',
    'game-achievement': '/animations/achievements/PDF/PDF.json',
  },
  images: {
    'levelSliderBackground-level_1': '/images/SliderBackgrounds/Kapitel1.jpg',
    'levelSliderBackground-level_2': '/images/SliderBackgrounds/Kapitel2.jpg',
    'levelSliderBackground-level_3': '/images/SliderBackgrounds/Kapitel3.jpg',
    'levelSliderBackground-level_4': '/images/SliderBackgrounds/Kapitel4.jpg',
    'levelSliderBackground-level_5': '/images/SliderBackgrounds/Kapitel5.jpg',
  },
};
